import { InputHTMLAttributes, forwardRef, useState } from "react";
import { cn } from "@/utils/cn";

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  error?: boolean;
  helperText?: string;
  prefixIcon?: React.ReactNode;
  showLength?: boolean;
  prefixActiveIcon?: React.ReactNode;
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, error, helperText, prefixIcon, showLength, prefixActiveIcon, ...props }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
      <div className="relative w-full flex items-center">
        {prefixIcon && (
          <div className="absolute left-3 focus:text-red">
            {!isFocused ? prefixIcon : (prefixActiveIcon || prefixIcon)}
          </div>
        )}
        <input
          ref={ref}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className={cn(
            "w-full px-3.5 h-11 rounded-sm",
            "border border-[rgba(208,213,221,1)] hover:border-[rgba(102,112,133,1)] focus:outline-none focus:border-black",
            "text-[rgba(16,24,40,1)] text-sm font-normal",
            "placeholder:text-[rgba(102,112,133,1)] placeholder:text-sm placeholder:font-normal",
            "disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-[rgba(217,45,32,1)] hover:border-[rgba(217,45,32,1)] focus:border-[rgba(217,45,32,1)]",
            className,
            prefixIcon && "pl-10",
            showLength && "pr-10"
          )}
          {...props}
        />
        {showLength && (
          <span className="absolute right-3 text-sm text-[rgba(152,162,179,1)]">
            {`${props.value?.toString().length || 0}/${props.maxLength}`}
          </span>
        )}
        {helperText && (
          <p
            className={cn(
              "absolute left-1 -bottom-4 mt-1 text-xs",
              error ? "text-[rgba(217,45,32,1)]" : "text-[rgba(102,112,133,1)]"
            )}
          >
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

TextInput.displayName = "TextInput";
